import { render, staticRenderFns } from "./ArticleFacebook.vue?vue&type=template&id=cfe5fee8&"
import script from "./ArticleFacebook.vue?vue&type=script&lang=ts&"
export * from "./ArticleFacebook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports